<template>
  <div class="arrowed">
    <div
      class="arrow"
      style="border-color: #027c00 #027c00 transparent transparent !important"
    ></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.arrowed {
  margin-bottom: 10px;
}

.arrow {
  margin: auto;
  position: relative;
  height: 0px;
  width: 0px;
  border: 12px solid;
  border-color: #027c00 #027c00 transparent transparent;
  transform: rotate(135deg);
}

.arrow:before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  display: block;
  height: 12px;
  width: 26px;
  background-color: #027c00 !important;
  --darkreader-inline-color: #027c00 !important;
  transform: rotate(-45deg) translate(2px, 5px);
}
</style>
